<template>
    <div style="width:1650px;height: 800px">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>轨迹列表</el-breadcrumb-item>
            <el-breadcrumb-item>地图展示</el-breadcrumb-item>
        </el-breadcrumb>
        <div id="map" style="width:100%;height: 900px;position: relative">
            <div  id="AMap" style="width:100%;height: 900px;" v-if="mapType == '高德'">

            </div>
            <div  id="BMap" style="width:100%;height: 900px;" v-if="mapType == '百度'">

            </div>
            <div  id="googleMap" style="width:100%;height: 900px;" v-if="mapType == '谷歌'" >
            </div>
            <div style="position: absolute;top:82%;right:100px;z-index: 9999;background-color: red">
                <img src="../../assets/bg.png">
            </div>
            <div style="position: absolute;top:20px;right:20px;z-index: 9999">
                <el-radio-group v-model="mapType" size="mini" @change="mapTypeChange">
                    <el-radio-button label="高德"></el-radio-button>
                    <el-radio-button label="百度"></el-radio-button>
                    <el-radio-button label="谷歌"></el-radio-button>
                </el-radio-group>
                <el-button plain style="margin-left: 10px" @click="setOpen"  size="mini">切换统计图</el-button>
            </div>
        </div>
        <el-divider v-show="show"></el-divider>
        <div v-show="show" style="width:1700px;height: 450px;position: relative;" id="echarts">

        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    export default {
        name: "mapList",
        data() {
            return {
                productList:[],
                numList:[],
                show:false,
                phone:'',
                username:'',
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    username:'',
                    phone:'',
                    deviceId:'',
                    equipmentId:'',//检测设备id
                    time:[],

                },
                trackList: {
                    records: [],
                    total: 0
                },
                // 地图类型
                mapType: "高德",
                // 控制修改订单对话框的显示与隐藏
                trackDialogVisible: false,
                // 路径
                ApathList: [],//高德
                ptpList:[],
                BpathList: [],//百度
                GpathList:[],//谷歌
                // 全局地图对象
                trackMap: null,
                row: {}

            }
        },
        mounted() {
            const href = window.location.href
            const str = href.substr(href.indexOf("?")+1,href.length)
            const params = str.split('&')
            const code = params[0].split('=')[1]
            this.row.id=code
            this.openMap()
        },
        methods: {
            setOpen(){
                if(this.show) {
                    this.show = false
                    document.getElementById("map").style.height = '900px'
                    if (this.mapType == "高德") {
                        document.getElementById("AMap").style.height = '900px'
                    }else if(this.mapType == "百度"){
                        document.getElementById("BMap").style.height = '900px'
                    }else if(this.mapType == '谷歌'){
                        document.getElementById("googleMap").style.height = '900px'
                    }
                }else{
                    this.show = true
                    document.getElementById("map").style.height = '450px'
                    if (this.mapType == "高德") {
                        document.getElementById("AMap").style.height = '450px'
                    }else if(this.mapType == "百度"){
                        document.getElementById("BMap").style.height = '450px'
                    }else if(this.mapType == '谷歌'){
                        document.getElementById("googleMap").style.height = '450px'
                    }
                    this.echarts(this.numList)
                }
            },
            echarts(dataList){
                var myChart = echarts.init(document.getElementById('echarts'));
                // 绘制图表
                var dataEnvironment = [];//环境温度
                var dataPavement = [];//路面温度
                var datax = [];
                for (var i = 1; i < dataList.length; i++) {
                    datax.push(dataList[i].creationTime);
                    dataPavement.push(dataList[i].pavementTemperature)
                    dataEnvironment.push(dataList[i].environmentTemperature)
                }
                var    option = {
                    color: ['#458FE3', '#48C964', '#FFAE37', '#FB8989', '#CA89FB'],
                    title: {
                        text: '温度展示',
                        x: 'center',
                        top: '0%',
                        textStyle: { color: '#2D527C', fontSize: '16', fontWeight: 'bold' }
                    },
                    legend: {
                        top: '5%',
                    },
                    grid: {
                        left: '5%',
                        right: '5%',
                        top: '10%',
                        bottom: '0%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' }, // cross 十字准星指示器 / shadow 阴影指示器
                        backgroundColor: '#2D527C',
                        formatter: (params) => {
                            let Htm = `<span>${params[0].name}</span><br>`;
                            params.forEach((item, index) => {
                                let { marker, seriesName, value } = item;
                                Htm += `${marker}
                          <span style="display:inline-block;margin-right:4px;width:70px;height:18px;line-height:24px;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${seriesName}</span>
                             <span style="display:inline-block;margin-right:12px;">${String(value) == 'NaN' ? '-' : value}</span>
                              ${(index + 1) % 2 === 0 ? '<br>' : ''}`;
                            })
                            return Htm
                        }
                    },
                    toolbox: {
                        show: true,
                        top: '10%',
                        right: '4%',
                        feature: {
                            dataView: {
                                // 数据视图
                                optionToContent: (opt) => {
                                    var axisData = opt.xAxis[0].data;
                                    var series = opt.series;
                                    var table = `<div class="echartstableview"><table style="width:100%;text-align:center">
                                                     <thead><tr><th>时间</th>`;
                                    series.forEach((element, index) => {
                                        table += `<th>${element.name}</th>`;
                                    });
                                    table += `</tr></thead><tbody>`;
                                    axisData.forEach((date, index) => {
                                        table += `<tr><td>${date}</td>`;
                                        series.forEach((series_, index_) => {
                                            table += `<td>${series_.data[index]}</td>`;
                                        });
                                        table += `</tr>`;
                                    });
                                    table += '</tbody></table></div>';
                                    return table;
                                },
                            },
                            dataZoom: {
                                yAxisIndex: 'none'
                            },
                            magicType: { type: ['line', 'bar'] },
                            restore: {},
                            saveAsImage: {}
                        },
                    },
                    xAxis: {
                        axisTick: { show: false },
                        axisLabel: {
                            textStyle: { color: '#707070', fontSize: 14 }
                        },
                        axisLine: {
                            // onZero: false, // X轴脱离Y轴0刻度
                            lineStyle: { color: '#707070', type: 'dashed'}
                        },
                        data: datax
                    },
                    yAxis: {
                        name: '气温（℃）',
                        nameTextStyle: { color: '#707070', fontSize: 14 },
                        axisLabel: {
                            textStyle: { color: '#707070', fontSize: 14 },
                            // 箭头旁y轴不显示最大值
                            showMaxLabel: false
                        },
                        axisLine: {
                            show: true,
                            symbol: ['none', 'arrow'],
                            symbolOffset: [0, 4],
                            lineStyle: { color: '#707070' }
                        },
                        splitLine: { show:false },
                        boundaryGap: [0, 0.1]
                    },
                    series: [
                        {
                            name: '路面温度',
                            type: 'line',
                            symbolSize: 8,
                            data: dataPavement
                        },
                        {
                            name: '环境温度',
                            type: 'line',
                            symbolSize: 8,
                            data: dataEnvironment
                        },
                    ],
                };
                myChart.setOption(option)
            },
            // 修改地图类型
            mapTypeChange(e) {
                this.mapType = e;
                this.openMap()
            },
            async openMap() {
                if (this.mapType == "高德") {
                    let params = {
                        id: this.row.id
                    }
                    const {data: res} = await this.$http.post(`/pavementtrackpoint//amp_track_point_list`, params);
                    if (res.code !== 1) return this.$message.error("查询轨迹失败");
                    this.ApathList = res.data.dataList
                    this.initAMap()
                } else if (this.mapType == "百度") {
                    let params = {
                        id: this.row.id
                    }
                    const {data: resp} = await this.$http.post(`/pavementtrackpoint/baidu_track_point_list`, params);
                    if (resp.code !== 1) return this.$message.error("查询轨迹失败");
                    this.BpathList = resp.data.dataList
                    this.initBMap()
                } else if (this.mapType == "谷歌") {
                    let params = {
                        id: this.row.id
                    }
                    const {data: resp} = await this.$http.post(`/pavementtrackpoint/google_track_point_list`, params);
                    if (resp.code !== 1) return this.$message.error("查询轨迹失败");
                    this.GpathList = resp.data.dataList
                    this.initGoogleMap()
                }
                let params = {
                    id: this.row.id
                }
                const {data: resp} = await this.$http.post(`/pavementtrackpoint/getTrackPoint`, params);
                if (resp.code !== 1) return this.$message.error("查询统计数据败");
                this.numList=resp.data
                this.echarts(resp.data)
            },
            // 高德地图加载轨迹
            // 初始化地图
            initAMap() {
                var _this=this
                let map = new AMap.Map('AMap', {
                    resizeEnable: true,
                    zoom: 17,
                });
                this.trackMap = map;
                AMap.plugin(['AMap.ToolBar','AMap.Scale','AMap.OverView'],function(){
                    map.addControl(new AMap.ToolBar());
                    map.addControl(new AMap.Scale());
                })
                map.on('click', () => {

                });

                //加载PathSimplifier，loadUI的路径参数为模块名中 'ui/' 之后的部分
                AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
                    if (!PathSimplifier.supportCanvas) {
                        alert('当前环境不支持 Canvas！');
                        return;
                    }

                    var pathSimplifierIns = new PathSimplifier({
                        zIndex: 100,
                        //autoSetFitView:false,
                        map: map, //所属的地图实例

                        getPath: function(pathData, pathIndex) {

                            return pathData.path;
                        },
                        getHoverTitle: function(pathData, pathIndex, pointIndex) {
                            var name;
                            switch(pathData.name) {
                                case "1":
                                    name='DRY(干)'//  干
                                    break;
                                case "2":
                                    name='MOIST(潮)'//潮
                                    break;
                                case "3":
                                    name='WET(湿)'//湿
                                    break;
                                case "6":
                                    name='SNOW(雪)'//雪
                                    break;
                                case "7":
                                    name='ICE(冰)'//冰
                                    break;
                                case "8":
                                    name='雾'//雾
                                    break;
                                case "9":
                                    name='SLUSHY(混合物、泥泞)'//混合物
                                    break;
                                default:
                                    name='无'
                            }
                            if (pointIndex >= 0) {
                                //point
                                return '路面状况'+name + '，经度：' + pathData.path[pathIndex][0]+'，纬度：'+ pathData.path[pathIndex][1];
                            }

                            return '路面状况'+name + '，点数量' + pathData.path.length;
                        },
                        renderOptions: {
                            renderAllPointsIfNumberBelow: 100,
                            //轨迹线的样式
                            pathLineStyle: {
                                dirArrowStyle: true
                            },
                            getPathStyle: function(pathItem, zoom) {
                                var  lineWidth = Math.round(4 * Math.pow(1.1, zoom - 3));
                                var color = null;
                                switch(pathItem.pathData.name) {
                                    case "1":
                                        color='#2BE905'//  干
                                        break;
                                    case "2":
                                        color='#00FFFF'//潮
                                        break;
                                    case "3":
                                        color='#0000FF'//湿
                                        break;
                                    case "6":
                                        color='#FFFFFF'//雪
                                        break;
                                    case "7":
                                        color='#FF0000'//冰
                                        break;
                                    case "8":
                                        color='#651CC6'//雾
                                        break;
                                    case "9":
                                        color='#FF00FF'//混合物
                                        break;
                                    default:
                                        color='#990099'
                                }
                                return {
                                    pathLineHoverStyle: {
                                        lineWidth: lineWidth,
                                        strokeStyle: '#cccccc',
                                        borderStyle: '#cccccc',
                                        dirArrowStyle: false
                                    },
                                    pathLineStyle: {
                                        strokeStyle: color,
                                        lineWidth: lineWidth
                                    },
                                    pathLineSelectedStyle: {
                                        lineWidth: lineWidth ,
                                        strokeStyle: '#cccccc',
                                        borderWidth: 1,
                                        borderStyle: '#cccccc',
                                        dirArrowStyle: true
                                    },
                                    // pathNavigatorStyle: {
                                    //     fillStyle: color
                                    // }
                                };
                            }
                        }
                    });

                    window.pathSimplifierIns = pathSimplifierIns;

                    //设置数据
                    pathSimplifierIns.setData(_this.ApathList);

                    // //对第一条线路（即索引 0）创建一个巡航器
                    // var navg1 = pathSimplifierIns.createPathNavigator(0, {
                    //     loop: true, //循环播放
                    //     speed: 1000000 //巡航速度，单位千米/小时
                    // });
                    //
                    // navg1.start();
                });
            },
            // initAMapPath() {
            //
            // for(var i=0;i<this.ApathList.length;i++) {
            //
            //     let polyline = new AMap.Polyline({
            //         map: this.trackMap,
            //         path: this.ApathList[i].mapList,
            //         showDir: true,
            //         strokeColor: "#1f1f1f",  //线颜色
            //         strokeWeight: 6,      //线宽
            //     });
            //     polyline.setMap(this.trackMap);
            // }
            //     this.trackMap.setFitView();
            // },
            // 百度地图加载轨迹
            initBMap() {
                var _this=this
                let map = new BMapGL.Map('BMap'); // 创建Map实例
                map.centerAndZoom(new BMapGL.Point(_this.BpathList[0].path[0][0], _this.BpathList[0].path[0][1]), 18); // 初始化地图,设置中心点坐标和地图级别
                map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
                map.enableResizeOnCenter()
                var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
                map.addControl(scaleCtrl);
                var zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
                map.addControl(zoomCtrl);
                var cityCtrl = new BMapGL.CityListControl();  // 添加城市列表控件
                map.addControl(cityCtrl);
                // map.setViewport(_this.BpathList[0].path[0])
                this.trackMap = map;
                for (let i = 0; i < _this.BpathList.length; i++) {
                    console.log(_this.BpathList[i].path)
                    let BMapPath=[]
                    for (let y = 0; y < _this.BpathList[i].path.length; y++) {
                        BMapPath.push(new BMapGL.Point(_this.BpathList[i].path[y][0], _this.BpathList[i].path[y][1]))
                    }
                    var color='';
                    switch(_this.BpathList[i].name) {
                        case "1":
                            color='#2BE905'//  干
                            break;
                        case "2":
                            color='#00FFFF'//潮
                            break;
                        case "3":
                            color='#0000FF'//湿
                            break;
                        case "6":
                            color='#FFFFFF'//雪
                            break;
                        case "7":
                            color='#FF0000'//冰
                            break;
                        case "8":
                            color='#651CC6'//雾
                            break;
                        case "9":
                            color='#FF00FF'//混合物
                            break;
                        default:
                            color='#990099'
                    }
                    let polyline = new BMapGL.Polyline(BMapPath, {
                        strokeColor: color,
                        strokeWeight: 6
                    });
                    this.trackMap.addOverlay(polyline);
                }
            },

            // 谷歌地图
            initGoogleMap() {
                var _this=this
                var mapProp = {
                    center: new google.maps.LatLng(_this.GpathList[0].path[0][1], _this.GpathList[0].path[0][0]),
                    zoom:17,
                    mapTypeId:google.maps.MapTypeId.ROADMAP
                };
                var map=new google.maps.Map(document.getElementById("googleMap"),mapProp);

                this.trackMap = map;
                for (var i = 0; i < _this.GpathList.length ; i++) {
                    let GMapPath=[]
                    for (let y = 0; y < _this.GpathList[i].path.length; y++) {
                        GMapPath.push(new google.maps.LatLng(_this.GpathList[i].path[y][1], _this.GpathList[i].path[y][0]))
                    }
                    var color='';
                    switch(_this.GpathList[i].name) {
                        case "1":
                            color='#2BE905'//  干
                            break;
                        case "2":
                            color='#00FFFF'//潮
                            break;
                        case "3":
                            color='#0000FF'//湿
                            break;
                        case "6":
                            color='#FFFFFF'//雪
                            break;
                        case "7":
                            color='#FF0000'//冰
                            break;
                        case "8":
                            color='#651CC6'//雾
                            break;
                        case "9":
                            color='#FF00FF'//混合物
                            break;
                        default:
                            color='#990099'
                    }
                    //创建线路
                    var polylineOptions =
                        {
                            path: GMapPath,//所有的GPS坐标点
                            strokeColor: color, //线路颜色
                            strokeWeight: 6,//线路大小
                        };
                    //绘制线路
                    var poly2 = new google.maps.Polyline(polylineOptions);
                    poly2.setMap(map);
                }

            },
            // initGoogleMapPath() {
            //     var myTrip = [stavanger, amsterdam, london];
            //     var flightPath = new google.maps.Polyline({
            //         path: myTrip,
            //         strokeColor: "#0000FF",
            //         strokeOpacity: 0.8,
            //         strokeWeight: 2
            //     });
            // }
        }
    }
</script>

<style scoped>

</style>
